import { POSITIONS } from "@besenliga/shared";
import type { Team } from "@besenliga/sim";
import type { Position } from "@besenliga/shared";

export interface LabeledLine {
  id: string;
  team: Team;
  role: Position;
  you: boolean;
}

/** Nome de cada linha do resultado: você, ou a posição com número (os bots ainda não têm nome). */
export function lineLabels(lines: readonly LabeledLine[], you: string): Record<string, string> {
  const count: Record<string, number> = {};
  const out: Record<string, string> = {};
  for (const l of lines) {
    if (l.you) {
      out[l.id] = you;
      continue;
    }
    const k = `${l.team}-${l.role}`;
    count[k] = (count[k] ?? 0) + 1;
    out[l.id] = `${POSITIONS[l.role].label} ${count[k]} (bot)`;
  }
  return out;
}
